import { ContractAwardsRepository } from "@/api/Repositories";

export default {
  namespaced: true,
  state: {
    contracts: []
  },
  mutations: {
    getContracts (state, contracts) {
      state.contracts = []
      state.contracts = contracts
    }
  },
  actions: {
    // Get
    getContracts ({ commit }, obj) {
      return new Promise((resolve, reject) => {
        ContractAwardsRepository.getAll(obj)
          .then(response => {
            const contracts = response.data.data.reverse()
            commit('getContracts', contracts)
            resolve();
          })
          .catch(error => {
            reject(error);
          })
      })
    },
    // Actions    
    createContract (context, contract) {
      return new Promise((resolve, reject) => {
        ContractAwardsRepository.create(contract)
          .then(() => {
            resolve();
          })
          .catch(errorCreate => {
            reject(errorCreate);
          });
      });
    },
    editContract (context, contract) {
      return new Promise((resolve, reject) => {
        ContractAwardsRepository.update(contract)
          .then(() => {
            resolve();
          }).catch(errorEdit => {
            reject(errorEdit);
          });
      });
    },
    deleteContract (context, id) {
      return new Promise((resolve, reject) => {
        ContractAwardsRepository.delete(id)
          .then(() => {
            resolve();
          })
          .catch(errorDelete => {
            reject(errorDelete);
          });
      });
    }
  }
}
